import { DragEvent, MouseEvent, TouchEvent, useRef, useState } from 'react';

export const useLongPress = (
  onTouchStartCallback?: () => void,
  onTouchEndCallback?: () => void
) => {
  const [isPressed, setIsPressed] = useState(false);

  const timeout = useRef<ReturnType<typeof setInterval> | null>(null);

  const handleTouchStart = (e: React.TouchEvent) => {
    e.persist();

    timeout.current = setTimeout(() => {
      setIsPressed(true);
      onTouchStartCallback?.();
    }, 400);
  };

  const handleTouchEnd = (e: TouchEvent) => {
    if (isPressed) {
      e.preventDefault();
    }
    onTouchEndCallback?.();

    timeout?.current && clearTimeout(timeout.current);
    setIsPressed(false);
  };

  const handleTouchMove = () => {
    timeout?.current && clearTimeout(timeout.current);
  };

  const touchHandlers = {
    onTouchStart: handleTouchStart,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onContextMenu: (e: MouseEvent) => e.preventDefault(),
    onContextMenuCapture: (e: MouseEvent) => e.preventDefault(),
    onDragStart: (e: DragEvent) => e.preventDefault(),
  };

  return { isPressed, touchHandlers };
};
